import { render } from "./MetaTipsStep.vue?vue&type=template&id=13620075"
import script from "./MetaTipsStep.vue?vue&type=script&lang=ts"
export * from "./MetaTipsStep.vue?vue&type=script&lang=ts"
script.render = render

export default script